import React from "react"


import { Card, Col, Container, Row } from "react-bootstrap"
import { parsedUser } from "../../common/GetCurrentUser"

function CreateLaborAccessRequestPage() {
  const user = parsedUser()
  return (
    <Container>
      <Row>
        <Col xs={12} md={6} className="mx-auto">
          <Card>
            <Card.Header>
              <Card.Title>Validación del Representante Laboral</Card.Title>
            </Card.Header>
            <Card.Body>
              <label>URL</label>
              <br />
              <small className="text-muted mb-4">
                Utilice el siguiente enlace para crear una solicitud nueva de
                acceso laboral
              </small>
              <input
                type="text"
                className="form-control"
                value={
                  "https://dataworker.com.do/externalLaborAccessRequest/" +
                  user.OrganizationId
                }
              />
            </Card.Body>
            <Card.Footer className="text-end">
              <button
                className="btn btn-primary"
                onClick={() => {
                  navigator.clipboard.writeText(
                    "https://dataworker.com.do/externalLaborAccessRequest/" +
                    user.OrganizationId
                  )
                  alert("Enlace copiado al portapapeles")
                }}
              >
                Copiar enlace
              </button>
              <button
                className="btn btn-secondary ms-2"
                onClick={() => {
                  window.open(
                    "https://dataworker.com.do/externalLaborAccessRequest/" +
                    user.OrganizationId
                  )
                }}
              >
                Ir al enlace
              </button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default CreateLaborAccessRequestPage
